var contactFraud = {
    callUs: 'Cuando nos llame, revisaremos toda la actividad reciente y confirmaremos que los cargos que se hayan hecho en su cuenta le pertenezcan. Si no reconoce algún cargo, iniciaremos un reclamo.',
    contact: 'Comuníquese con Nosotros',
    description: 'Por favor, llámenos por teléfono tan pronto como sea posible para que podamos determinar con usted si hubo alguna actividad no autorizada.',
    fraudDisclaimer: '<0>$0 de Responsabilidad por Fraude:</0> Usted nunca será responsable por cargos no autorizados',
    fraudPrevention: 'Sugerencias y Preguntas Frecuentes sobre Prevención de Fraude',
    title: 'Para completar esta solicitud, necesitamos conectarlo con un representante de nuestro Equipo de Soluciones de Fraude.'
};
export default contactFraud;
//# sourceMappingURL=contactFraud.js.map